import Vue from 'vue'
import Router from 'vue-router'
import { getAuthUser } from './../misc/auth.js';
import Login from '@/components/Login/Login'
import Home from '@/components/Home/Home'
import _Class from '@/components/ClassView/Class'
import Lecture from '@/components/Lecture/Lecture'
import Subject from '@/components/Subject/Subject'
import Exercise from '@/components/Exercise/Exercise'
import EachExercise from '@/components/EachExercise/EachExercise'
import Exam from '@/components/Exam/Exam'
import StudentPanel from '@/components/StudentPanel/StudentPanel'
import YourExam from '@/components/YourExam/YourExam'
import ChangePassword from '@/components/ChangePassword/ChangePassword'
import ExamDetail from '@/components/ExamDetail/ExamDetail'
import NihomType from '@/components/Nihom/NihomType/NihomType.vue';
import NihomSubType from '@/components/Nihom/NihomSubType/NihomSubType.vue';
import NihomContent from '@/components/Nihom/NihomContent/NihomContent.vue';
import NihomContentView from '@/components/Nihom/NihomContent/NihomContentView.vue';
import Dictionary from '@/components/Dictionary/Dictionary.vue';


Vue.use(Router)

var router=new Router({
  
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/class/:id',
      name: 'Class',
      component: _Class,
      meta: {
        auth: true
      }
    },
    {
      path: '/lecture/:id',
      name: 'Lecture',
      component: Lecture,
      meta: {
        auth: true
      }
    },
    {
      path: '/subject/:id/:course_id/:class_id',
      name: 'Subject',
      component: Subject,
      meta: {
        auth: true
      }
    },
    
    {
      path: '/exam/:id',
      name: 'Exam',
      component: Exam,
      meta: {
        auth: true
      }
    },
    {
      path: '/student-panel',
      name: 'StudentPanel',
      component: StudentPanel,
      meta: {
        auth: true
      }
    },
    {
      path: '/your-exam',
      name: 'YourExam',
      component: YourExam,
      meta: {
        auth: true
      }
    },
    {
      path: '/change-pw',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        auth: true
      }
    },
    {
      path: '/exam-detail/:id',
      name: 'ExamDetail',
      component: ExamDetail,
      meta: {
        auth: true
      }
    },
    {
      path: '/nihom-type',
      name: 'Nihom',
      component: NihomType,
      meta: {
        auth: true
      } 
    },
    {
      path: '/nihom-sub-type/:id',
      name: 'Nihom',
      component: NihomSubType,
      meta: {
        auth: true
      }
    },
    {
      path: '/nihom-content/:id',
      name: 'Nihom',
      component: NihomContent,
      meta: {
        auth: true
      }
    },
    {
      path: '/nihom-content-view/:id',
      name: 'Nihom',
      component: NihomContentView,
      meta: {
        auth: true
      }
    },
    {
      path: '/exercises/:subject_id/:class_id',
      name: 'Exercise',
      component: Exercise,
      meta: {
        auth: true
      }
    },
    {
      path: '/exercise/:id',
      name: 'EachExercise',
      component: EachExercise,
      meta: {
        auth: true
      }
    },
    {
      path: '/dictionary',
      name: 'Dictionary',
      component: Dictionary,
      meta: {
        auth: true
      }
    },

    
    
    
    
    
    
    
   
   
  ]
})

router.beforeEach((to, from, next) => {
  document.title = `Online Learning Site || ${to.name}`
  if (to.matched.some(record => record.meta.auth)) {
    if (getAuthUser()) {
      next();
    }
    else {

      next({ name: 'Login' })
    }
  }
  else {
    next();
  }
})


export default router;